export enum gatherClientStatus {
  NOT_RELATION = 0, // 未关联的-未录入
  WILL_APPROVAL, // 待审批
  APPROVAL, // 审核中
  PASS, // 审核通过
  DENY, // 已驳回-审核驳回
  REJECT, // 不通过-审核拒绝
}

// export enum tabsKeys {
//   firstTabKey = 'firstTabKey',
//   secondTabKey = 'secondTabKey',
//   thirdTabKey = 'thirdTabKey'
// }
// export const LineColor = {
//   [tabsKeys.firstTabKey]: {
//     color: '#549BFF',
//     hoverColor: '#006AFF'
//   },
//   [tabsKeys.secondTabKey]: {
//     color: '#FFC28E',
//     hoverColor: '#FF861D'
//   },
//   [tabsKeys.thirdTabKey]: {
//     color: '#7FCCB1',
//     hoverColor: '#009963'
//   },
// };

/** 如果 key 在预定义的颜色中，返回对应的颜色，否则动态生成 */
export const dynamicLineColor = (key:string) => {
  const predefinedColors = {
    '0': {
      color: '#549BFF',
      hoverColor: '#006AFF',
    },
    '1': {
      color: '#FFC28E',
      hoverColor: '#FF861D',
    },
    '2': {
      color: '#7FCCB1',
      hoverColor: '#009963',
    },
  };

  // 动态生成颜色
  const generateColor = (key) => {
    const baseHue = (parseInt(key, 10) * 137) % 360; // 基于 key 生成色相
    const transparency = 0.4; // 设置透明度 (0~1)
    const baseColor = `hsla(${baseHue}, 70%, 50%, ${transparency})`; // 主色 (透明度)
    const hoverColor = `hsla(${baseHue}, 80%, 40%, ${transparency})`; // 悬停色 (透明度)
    return { color: baseColor, hoverColor: hoverColor };
  };
  return predefinedColors[key] || generateColor(key);
};
